module.exports = __webpack_public_path__ + "cfbea7f109a466771780c0bf42034b3a.pdf";